export const kordisKit = {
  overview: {
    src: 'https://cdn.magicpatterns.com/uploads/naj6Hs6iqrtt5suQQZW7GK/image.png',
    alt: 'The Chat CFO UI Kit in Magic Patterns: nine components including AI Disclosure, AI Draft Container, AI Insight, AI Lockups, Chatbot Page, Chat Input, Create Skill Modal and Thinking Tool Call Chat',
  },
  logo: 'https://cdn.magicpatterns.com/uploads/5yV26iAivStF4YYQJLLhSt/logo-kordis-small.png',
  palette: [
    { name: 'Slate Blue', hex: '#6666E9', role: 'Actions, AI accents' },
    { name: 'Cerise Red', hex: '#DB334D', role: 'Brand, negative trends' },
    { name: 'Jacarta', hex: '#462E62', role: 'Deep accents' },
    { name: 'Black', hex: '#000000', role: 'Text and figures' },
  ],
  insight: {
    title: 'Seasonal revenue pattern ahead of historical',
    description: 'Spring ramp-up started 3 weeks earlier than the 3-year historical average.',
    confidence: 'high confidence',
    source: 'QBO Revenue Trends',
    action: 'Adjust seasonality curve',
  },
  draft: {
    date: '2026-01-31',
    memo: 'Accrue January SaaS revenue',
    lines: [
      { account: '1200 · Accounts Receivable', debit: '$24,000', credit: '—' },
      { account: '4000 · SaaS Revenue', debit: '—', credit: '$24,000' },
    ],
  },
  thinkingSteps: ['Reading QuickBooks', 'Amortizing', 'Checking sources'],
};
